"use client";

import React, { useRef, useState } from "react";
import { X } from "lucide-react";
import * as S from "./styles";

const UploadAudio: React.FC = () => {
  const [audioSrc, setAudioSrc] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    setAudioSrc(url);
  };

  const handleRemove = () => {
    setAudioSrc(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <>
      <S.AudioUploadContainer>
        {!audioSrc ? (
          <S.UploadBox onClick={handleClick}>
            <span>+ Upload áudio</span>
          </S.UploadBox>
        ) : (
          <S.AudioBox>
            <audio controls src={audioSrc} />
            <S.Close onClick={handleRemove}>
              <X size={16} />
            </S.Close>
          </S.AudioBox>
        )}
        <input
          type="file"
          accept="audio/*"
          ref={inputRef}
          onChange={handleUpload}
          style={{ display: "none" }}
        />
      </S.AudioUploadContainer>
    </>
  );
};

export default UploadAudio;
